import {
  ArrowForwardIos,
  ContentCopy,
  Delete,
  RecordVoiceOver,
  Loop,
} from "@mui/icons-material";
import React, { memo } from "react";
import { useNodeStorage } from "../../../stores/useNodeStorage";
import { Handle } from "react-flow-renderer";

export default memo(({ data, isConnectable, id }) => {
  const storageItems = useNodeStorage();
  
  // Extraer datos del nodo - puede estar en data.voiceToVoice o directamente en data
  const nodeData = data.voiceToVoice || data;
  
  // Task 13.1: Detect loop configuration
  const hasLoop = nodeData.loop?.enabled || false;
  
  // Función para obtener el nombre de la conexión de WhatsApp
  const getConnectionName = () => {
    // Si ya tenemos el nombre guardado, usarlo
    if (nodeData.whatsappConnectionName) {
      return nodeData.whatsappConnectionName;
    }
    
    // Si no hay conexión asignada
    if (!nodeData.whatsappConnection && !nodeData.whatsappConnectionId) {
      return "No asignada";
    }
    
    // Si whatsappConnection es un objeto con name
    if (typeof nodeData.whatsappConnection === 'object' && nodeData.whatsappConnection.name) {
      return `${nodeData.whatsappConnection.name}${nodeData.whatsappConnection.number ? ' - ' + nodeData.whatsappConnection.number : ''}`;
    }
    
    // Si es solo un ID, mostrar el ID
    const connectionId = nodeData.whatsappConnectionId || nodeData.whatsappConnection;
    return `Conexión ${connectionId}`;
  };
  
  return (
    <div
      style={{
        backgroundColor: "#ffffff",
        padding: "8px",
        borderRadius: "8px",
        boxShadow: "rgba(0, 0, 0, 0.05) 0px 3px 5px",
        // Task 13.3: Update border styling for loop-enabled nodes
        border: hasLoop 
          ? "2px solid rgba(156, 39, 176, 0.5)" 
          : "1px solid rgba(156, 39, 176, 0.25)",
        minWidth: "200px",
        position: "relative",
      }}
    >
      <Handle
        type="target"
        position="left"
        style={{
          background: "#9c27b0",
          width: "18px",
          height: "18px",
          top: "20px",
          left: "-12px",
          cursor: "pointer",
        }}
        onConnect={(params) => console.log("handle onConnect", params)}
        isConnectable={isConnectable}
      >
        <ArrowForwardIos
          sx={{
            color: "#ffff",
            width: "10px",
            height: "10px",
            marginLeft: "2.9px",
            marginBottom: "1px",
            pointerEvents: "none",
          }}
        />
      </Handle>
      
      {/* Task 13.2: Add loop indicator badge */}
      {hasLoop && (
        <div
          style={{
            position: "absolute",
            top: -8,
            right: -8,
            backgroundColor: "#9c27b0",
            borderRadius: "50%",
            width: 20,
            height: 20,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            boxShadow: "0 2px 4px rgba(0,0,0,0.2)",
            zIndex: 10,
          }}
        >
          <Loop style={{ color: "white", fontSize: 12 }} />
        </div>
      )}
      
      <div
        style={{
          display: "flex",
          position: "absolute",
          right: 5,
          top: 5,
          cursor: "pointer",
          gap: 6,
        }}
      >
        <ContentCopy
          onClick={() => {
            storageItems.setNodesStorage(id);
            storageItems.setAct("duplicate");
          }}
          sx={{ width: "12px", height: "12px", color: "#9c27b0" }}
        />

        <Delete
          onClick={() => {
            storageItems.setNodesStorage(id);
            storageItems.setAct("delete");
          }}
          sx={{ width: "12px", height: "12px", color: "#9c27b0" }}
        />
      </div>
      
      <div
        style={{
          color: "#ededed",
          fontSize: "16px",
          flexDirection: "row",
          display: "flex",
          marginBottom: "8px",
        }}
      >
        <RecordVoiceOver
          style={{
            width: "18px",
            height: "18px",
            marginRight: "6px",
            marginTop: "2px",
            color: "#9c27b0"
          }}
        />
        <div style={{ color: "#232323", fontSize: "16px", fontWeight: "500" }}>
          Voice to Voice
        </div>
      </div>
      
      <div style={{ color: "#232323", fontSize: "12px" }}>
        <div
          style={{
            backgroundColor: "#f3e5f5",
            marginBottom: "6px",
            borderRadius: "5px",
            padding: "8px",
          }}
        >
          <div style={{ marginBottom: "4px" }}>
            <strong>Conexión:</strong> {getConnectionName()}
          </div>
          <div style={{ marginBottom: "4px" }}>
            <strong>Voz:</strong> {nodeData.voiceId || "Default"}
          </div>
          <div style={{ marginBottom: "4px" }}>
            <strong>Modelo:</strong> {nodeData.model || "eleven_multilingual_v2"}
          </div>
          {nodeData.name && (
            <div style={{ marginBottom: "4px" }}>
              <strong>Nombre:</strong> {nodeData.name}
            </div>
          )}
          {hasLoop && (
            <div style={{ 
              marginTop: "6px",
              padding: "4px 6px",
              backgroundColor: "#e1bee7",
              borderRadius: "4px",
              fontSize: "10px",
              fontWeight: "500",
              color: "#6a1b9a",
            }}>
              🔄 Loop habilitado ({nodeData.loop.maxIterations} max)
            </div>
          )}
          {nodeData.systemPrompt && (
            <div style={{ 
              marginTop: "6px", 
              fontSize: "11px", 
              color: "#666",
              maxHeight: "40px",
              overflow: "hidden",
              textOverflow: "ellipsis",
            }}>
              {nodeData.systemPrompt.substring(0, 80)}...
            </div>
          )}
        </div>
      </div>
      
      <Handle
        type="source"
        position="right"
        id="a"
        style={{
          background: "#9c27b0",
          width: "18px",
          height: "18px",
          top: "50%",
          right: "-11px",
          cursor: "pointer",
        }}
        isConnectable={isConnectable}
      >
        <ArrowForwardIos
          sx={{
            color: "#ffff",
            width: "10px",
            height: "10px",
            marginLeft: "2.9px",
            marginBottom: "1px",
            pointerEvents: "none",
          }}
        />
      </Handle>
    </div>
  );
});
